import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import axios from "axios";
import API_ROUTES from "../constants/apis";
import Footer from "./Footer";
import Navbar from "./Navbar";
import { GiCctvCamera, GiTap, GiKeyCard, GiPowerGenerator } from "react-icons/gi";
import {MdRecycling, MdOutlineWifiPassword, MdLocalLaundryService} from "react-icons/md";
import {CgGym} from "react-icons/cg";
import {BiBookReader, BiRestaurant} from "react-icons/bi";
import {BsBank,BsHouseGearFill, BsReception2} from "react-icons/bs";
import {FaPrescriptionBottle, FaShuttleVan} from "react-icons/fa";
import {GrLounge} from "react-icons/gr";
import single from "../assets/3dBedsitter.jpeg";
import double from "../assets/3dBedsitter.jpeg";
import bedsitter from "../assets/3dBedsitter.jpeg";
import one_bedroom from "../assets/3dBedsitter.jpeg";
import two_bedroom from "../assets/3dBedsitter.jpeg";
import three_bedroom from "../assets/3dBedsitter.jpeg";

function ResidenceDetails() {
  const { id } = useParams();
  const [residenceDetails, setResidenceDetails] = useState(null);
  const imageUrl = "https://res.cloudinary.com/ddtmsdlip/"

  

  useEffect(() => {
    axios
      .get(`${API_ROUTES.HOSTEL}${id}/`)
      .then((response) => {
        setResidenceDetails(response.data);
      })
      .catch((error) => {
        console.error("Error fetching residence details:", error);
      });
  }, [id]);

  return (
    <>
      <Navbar />
      <div className="mt-24 pt-2">
        {residenceDetails ? (
          <>
            <section className="hero grid md:grid-cols-2 gap-8 py-10 px-5 lg:px-60 xl:px-96 bg-red-600">
              <div className="hero-left order-last md:order-first">
                <h2 className="text-4xl text-blue-950 font-extrabold p-4">
                  Welcome to {residenceDetails.name}
                </h2>
                <p className="residence-desc text-white text-lg">
                  {residenceDetails.description}
                </p>
                <p className="slug-line p-4 text-center text-blue-950">
                  I promise, you will love it!
                </p>
              </div>
              <div className="hero-right rounded-md">
                <img
                  src={imageUrl + residenceDetails.picture}
                  alt=""
                  className="w-full h-full rounded-md"
                />
              </div>
            </section>
            <section className="features py-10 px-5 lg:px-60 xl:px-96 bg-slate-100">
              <div className="feature-header text-center">
                <h1 className="text-4xl text-blue-950 font-extrabold p-4">
                  Key Features at {residenceDetails.name}
                </h1>
                <p className="text-sky-500 p-4">Book and Enjoy your stay!</p>
              </div>
              {residenceDetails.features ? (
                <div className="grid grid-cols-2 md:grid-cols-6 gap-4">
                  {residenceDetails.features.includes("Garbage Collection") && (
                    <div className="flex flex-col p-4 ">
                      <div className="flex flex-col items-center">
                        <MdRecycling className="text-6xl text-red-600 border-2 border-blue-950 border rounded-full p-2 " />
                      </div>
                      <p className="text-center">Garbage Collection</p>
                    </div>
                  )}
                  {residenceDetails.features.includes("Residents Gym") && (
                    <div className="flex flex-col p-4 ">
                      <div className="flex flex-col items-center">
                        <CgGym className="text-6xl text-red-600 border-2 border-blue-950 border rounded-full p-2 " />
                      </div>
                      <p className="text-center">Residents Gym</p>
                    </div>
                  )}
                  {residenceDetails.features.includes("Quiet Study Areas") && (
                    <div className="flex flex-col p-4 ">
                      <div className="flex flex-col items-center">
                        <BiBookReader className="text-6xl text-red-600 border-2 border-blue-950 border rounded-full p-2 " />
                      </div>
                      <p className="text-center">Quiet Study Areas</p>
                    </div>
                  )}
                  {residenceDetails.features.includes("Key Card Access") && (
                    <div className="flex flex-col p-4 ">
                      <div className="flex flex-col items-center">
                        <GiKeyCard className="text-6xl text-red-600 border-2 border-blue-950 border rounded-full p-2 " />
                      </div>
                      <p className="text-center">Key Card Access</p>
                    </div>
                  )}
                  {residenceDetails.features.includes("Back-up Generator") && (
                    <div className="flex flex-col p-4 ">
                      <div className="flex flex-col items-center">
                        <GiPowerGenerator className="text-6xl text-red-600 border-2 border-blue-950 border rounded-full p-2 " />
                      </div>
                      <p className="text-center">Back-up Generator</p>
                    </div>
                  )}
                  {residenceDetails.features.includes("Pharmacy") && (
                    <div className="flex flex-col p-4 ">
                      <div className="flex flex-col items-center">
                        <FaPrescriptionBottle className="text-6xl text-red-600 border-2 border-blue-950 border rounded-full p-2 " />
                      </div>
                      <p className="text-center">Pharmacy</p>
                    </div>
                  )}
                  {residenceDetails.features.includes("Bank") && (
                    <div className="flex flex-col p-4 ">
                      <div className="flex flex-col items-center">
                        <BsBank className="text-6xl text-red-600 border-2 border-blue-950 border rounded-full p-2 " />
                      </div>
                      <p className="text-center">Bank</p>
                    </div>
                  )}
                  {residenceDetails.features.includes(
                    "Fully Furnished Rooms"
                  ) && (
                    <div className="flex flex-col p-4 ">
                      <div className="flex flex-col items-center">
                        <BsHouseGearFill className="text-6xl text-red-600 border-2 border-blue-950 border rounded-full p-2 " />
                      </div>
                      <p className="text-center">Fully Furnished Rooms</p>
                    </div>
                  )}
                  {residenceDetails.features.includes("High Speed WIFI") && (
                    <div className="flex flex-col p-4 ">
                      <div className="flex flex-col items-center">
                        <MdOutlineWifiPassword className="text-6xl text-red-600 border-2 border-blue-950 border rounded-full p-2 " />
                      </div>
                      <p className="text-center">High Speed WIFI</p>
                    </div>
                  )}
                  {residenceDetails.features.includes("Chillout Lounge") && (
                    <div className="flex flex-col p-4 ">
                      <div className="flex flex-col items-center">
                        <GrLounge className="text-6xl text-red-600 border-2 border-blue-950 border rounded-full p-2 " />
                      </div>
                      <p className="text-center">Chillout Lounge</p>
                    </div>
                  )}
                  {residenceDetails.features.includes(
                    "Constant Water Supply"
                  ) && (
                    <div className="flex flex-col p-4 ">
                      <div className="flex flex-col items-center">
                        <GiTap className="text-6xl text-red-600 border-2 border-blue-950 border rounded-full p-2 " />
                      </div>
                      <p className="text-center">Constant Water Supply</p>
                    </div>
                  )}
                  {residenceDetails.features.includes(
                    "CCTV & 24/7 Security"
                  ) && (
                    <div className="flex flex-col p-4 ">
                      <div className="flex flex-col items-center">
                        <GiCctvCamera className="text-6xl text-red-600 border-2 border-blue-950 border rounded-full p-2 " />
                      </div>
                      <p className="text-center">CCtv & 24/7 security</p>
                    </div>
                  )}
                  {residenceDetails.features.includes("Reception Area") && (
                    <div className="flex flex-col p-4 ">
                      <div className="flex flex-col items-center">
                        <BsReception2 className="text-6xl text-red-600 border-2 border-blue-950 border rounded-full p-2 " />
                      </div>
                      <p className="text-center">Reception Area</p>
                    </div>
                  )}
                  {residenceDetails.features.includes("Restaurants") && (
                    <div className="flex flex-col p-4 ">
                      <div className="flex flex-col items-center">
                        <BiRestaurant className="text-6xl text-red-600 border-2 border-blue-950 border rounded-full p-2 " />
                      </div>
                      <p className="text-center">Restaurants</p>
                    </div>
                  )}
                  {residenceDetails.features.includes(
                    "Pick & Drop Laundry"
                  ) && (
                    <div className="flex flex-col p-4 ">
                      <div className="flex flex-col items-center">
                        <GiCctvCamera className="text-6xl text-red-600 border-2 border-blue-950 border rounded-full p-2 " />
                      </div>
                      <p className="text-center">Pick & Drop Laundry</p>
                    </div>
                  )}
                  {residenceDetails.features.includes("Laundry Area") && (
                    <div className="flex flex-col p-4 ">
                      <div className="flex flex-col items-center">
                        <MdLocalLaundryService className="text-6xl text-red-600 border-2 border-blue-950 border rounded-full p-2 " />
                      </div>
                      <p className="text-center">Laundry Area</p>
                    </div>
                  )}
                  {residenceDetails.features.includes("Bus Shuttle") && (
                    <div className="flex flex-col p-4 ">
                      <div className="flex flex-col items-center">
                        <FaShuttleVan className="text-6xl text-red-600 border-2 border-blue-950 border rounded-full p-2 " />
                      </div>
                      <p className="text-center">Bus Shuttle</p>
                    </div>
                  )}
                </div>
              ) : (
                <p>Loading residence features...</p>
              )}
            </section>
            <section className="rooms py-10 px-5 lg:px-60 xl:px-96">
              <div className="rooms-header text-center">
                <h1 className="text-4xl text-blue-950 font-extrabold p-4">
                  Type of Rooms Available
                </h1>
              </div>
              <div>
                {residenceDetails.type_of_room ? (
                  <div className="grid grid-cols-2 gap-4 w-full">
                    {residenceDetails.type_of_room.includes("Single Rooms") && (
                      <div className="single-room">
                        <img src={single} alt="" className="rounded-t-lg" />
                        <p className="bg-red-600 text-center text-white text-xl font-bold rounded-b-lg">
                          Single Room
                        </p>
                      </div>
                    )}
                    {residenceDetails.type_of_room.includes("Double Rooms") && (
                      <div className="double-room">
                        <img src={double} alt="" className="rounded-t-lg" />
                        <p className="bg-red-600 text-center text-white text-xl font-bold rounded-b-lg">
                          Double Room
                        </p>
                      </div>
                    )}
                    {residenceDetails.type_of_room.includes("Bed Sitters") && (
                      <div className="bedsitter">
                        <img src={bedsitter} alt="" className="rounded-t-lg" />
                        <p className="bg-red-600 text-center text-white text-xl font-bold rounded-b-lg">
                          BedSitter
                        </p>
                      </div>
                    )}
                    {residenceDetails.type_of_room.includes("One Bedrooms") && (
                      <div className="one-bedroom">
                        <img
                          src={one_bedroom}
                          alt=""
                          className="rounded-t-lg"
                        />
                        <p className="bg-red-600 text-center text-white text-xl font-bold rounded-b-lg">
                          One BedRoom
                        </p>
                      </div>
                    )}
                    {residenceDetails.type_of_room.includes("Two Bedrooms") && (
                      <div className="two-bedroom">
                        <img
                          src={two_bedroom}
                          alt=""
                          className="rounded-t-lg"
                        />
                        <p className="bg-red-600 text-center text-white text-xl font-bold rounded-b-lg">
                          Two BedRoom
                        </p>
                      </div>
                    )}
                    {residenceDetails.type_of_room.includes(
                      "Three Bedrooms"
                    ) && (
                      <div className="three-bedroom">
                        <img
                          src={three_bedroom}
                          alt=""
                          className="rounded-t-lg"
                        />
                        <p className="bg-red-600 text-center text-white text-xl font-bold rounded-b-lg">
                          Three BedRoom
                        </p>
                      </div>
                    )}
                  </div>
                ) : (
                  <p>Loading residence Types of Rooms Available...</p>
                )}
              </div>
              <div className="book text-center m-5">
                <Link
                  to="/book"
                  className="bg-blue-950 hover:bg-red-700 text-white p-2 rounded-lg"
                >
                  Book Now {">"}{" "}
                </Link>
              </div>
            </section>
          </>
        ) : (
          <p>Loading residence details...</p>
        )}
      </div>
      <Footer />
    </>
  );
}

export default ResidenceDetails;
